export default __webpack_public_path__ + "static/media/236.640ce1c7.jpg";